import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AccountRouterManager } from '../../controller/router-handler';
import { ChangePin } from '../../models/changePin.model';
import { putChangePinServiceResModel } from '../../models/serviceResponse.model';
import { AccountModuleDisplayConfig, ACCOUNT_DISPLAY_CONFIG } from '../../module-config/module-config';
import { ChangePinService } from '../../services/change-pin.service';

@Component({
  selector: 'app-change-pin',
  templateUrl: './change-pin.component.html',
  styleUrls: ['./change-pin.component.css']
})
export class ChangePinComponent implements OnInit {
  isCreateNewPin: boolean = false;
  obUserPin = new ChangePin('', '', '', '', '');

  private accountRouter = new AccountRouterManager(this.router);

  constructor(
    private router: Router, 
    private translate: TranslateService, 
    private toastr: ToastrService, 
    private changePinService: ChangePinService,
    @Inject(ACCOUNT_DISPLAY_CONFIG) private accountRouterConfig: AccountModuleDisplayConfig,
  ) {

    this.accountRouter.setRouterConfig(accountRouterConfig.displayAreaConfig);
    
    if(this.router.getCurrentNavigation()?.extras.state && this.router.getCurrentNavigation()?.extras.state?.accountInfo.otpCode && this.router.getCurrentNavigation()?.extras.state?.accountInfo.refNo){
      this.obUserPin.refNo = this.router.getCurrentNavigation()?.extras.state?.accountInfo.refNo;
      this.obUserPin.otpCode = this.router.getCurrentNavigation()?.extras.state?.accountInfo.otpCode;
      this.isCreateNewPin = true;
    }
  }

  ngOnInit(): void {
  }

  async savePin(){
    if(this.isCreateNewPin === false){
      if(this.obUserPin.oldPin == ''){
        this.toastr.error(this.translate.instant('ACCOUNT_CHANGEPIN_MISSING_PARAMETER_ERROR'));
        return;
      }
      if(this.obUserPin.oldPin.length != 6){
        this.toastr.error(this.translate.instant('ACCOUNT_CHANGEPIN_MISSING_PARAMETER_ERROR'));
        return;
      }
    }
    if(this.obUserPin.newPin == ''){
      this.toastr.error(this.translate.instant('ACCOUNT_CHANGEPIN_MISSING_PARAMETER_ERROR'));
      return;
    }
    if(this.obUserPin.newPin.length != 6){
      this.toastr.error(this.translate.instant('ACCOUNT_CHANGEPIN_MISSING_PARAMETER_ERROR'));
      return;
    }
    if(this.obUserPin.newPinRepeat == ''){
      this.toastr.error(this.translate.instant('ACCOUNT_CHANGEPIN_MISSING_PARAMETER_ERROR'));
      return;
    }
    if(this.obUserPin.newPinRepeat.length != 6){
      this.toastr.error(this.translate.instant('ACCOUNT_CHANGEPIN_MISSING_PARAMETER_ERROR'));
      return;
    }
    if(this.obUserPin.newPinRepeat !== this.obUserPin.newPin){
      this.toastr.error(this.translate.instant('ACCOUNT_CHANGEPIN_PINS_DONT_MATCH'));
      return;
    }

    let message = await this.changePin();
    if(message == ''){
      this.toastr.success(this.translate.instant('ACCOUNT_CHANGEPIN_SUCCESSFUL_OPERATION'));
      this.accountRouter.toMyAccount();
    }
    else{
      this.toastr.error(message);
      return;
    }
  }

  async changePin(){
    return this.callChangePinService()
      .then(function(values){
        return '';
      })
      .catch(function(err){
        return err;
      })
  }

  callChangePinService(){
    return new Promise((resolve, reject) => {
      this.changePinService.putChangePassword(this.obUserPin).subscribe(
        (response: putChangePinServiceResModel) => {
          if(response.error === true){
            return reject(response.message);
          }
          else{
            return resolve(true);
          }
        },
        error => {
          return reject(error);
        }
      )
    })
  }

  onCancel(){
    this.accountRouter.onCancelProcessDefault();
  }
  
}
